/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {cancelInvestmentOrder} from '../api'

export const useMutationCancelInvestmentOrder = createReactQueryMutationHook('cancelInvestmentOrder', cancelInvestmentOrder)
